import { combineReducers } from 'redux'
import appReducer from './AppReducer'
import authReducer from './AuthReducer'
import publicReducer from './PublicReducer'
import { intlReducer } from 'react-intl-redux'
import ClientsReducer from './ClientsReducer'
import ClientReducer from './ClientReducer'
import SearcherReducer from './SearcherReducer'
import AssetsFavoritesReducer from './AssetsFavoritesReducer'
import AssetsExploreReducer from './AssetsExploreReducer'
import AssetsExploreUploadReducer from './AssetsExploreUploadReducer'
import AssetsShareReducer from './AssetsShareReducer'
import AssetsPublicSharedReducer from './AssetsPublicSharedReducer'
import AssetsRootReducer from './AssetsRootReducer'
import AssetsRootUploadReducer from './AssetsRootUploadReducer'
import AssetsLastUploadReducer from './AssetsLastUploadReducer'
import AssetsConfirmReducer from './AssetsConfirmReducer'
import BitacoraReducer from './BitacoraReducer'
import UsersReducer from './UsersReducer'
import InviteReducer from './InviteReducer'
import PermissionReducer from './PermissionReducer'
import GroupReducer from './GroupReducer'
import HoverVerticalReducer from './HoverVerticalReducer'
import NotificationReducer from './NotificationReducer'
import JobsReducer from './JobsReducer'
import CommentReducer from './CommentReducer'
import DownloadReducer from './DownloadReducer'
import MiddleViewReducer from './MiddleViewReducer';
import awsAuthReducer from './awsAuthReducer'; // Added for AWS Auth, path corrected
import BunkeyHostReducer from "./BunkeyHostReducer"
import CountryCodesReducer from "./CountryCodesReducer";
import PlanServicesReducer from "./PlanServicesReducer";
import MultiselectReducer from "./MultiselectReducer";
import StorageReducer from "./StorageReducer";
import TrashReducer from "./TrashReducer";
import UploadFolderReducer from "./UploadFolderReducer";
import IndividualSelectReducer from "./IndividualSelectReducer";
import ToursReducer from "./ToursReducer";

const rootReducer = combineReducers({
  app: appReducer,
  authUser: authReducer,
  clients: ClientsReducer,
  client: ClientReducer,
  searcher: SearcherReducer,
  public: publicReducer,
  assetsExplore: AssetsExploreReducer,
  assetsExploreUpload: AssetsExploreUploadReducer,
  assetsRoot: AssetsRootReducer,
  assetsRootUpload: AssetsRootUploadReducer,
  assetsShared: AssetsShareReducer,
  assetsPublicShared: AssetsPublicSharedReducer,
  assetsFavorites: AssetsFavoritesReducer,
  assetsLastUploads: AssetsLastUploadReducer,
  assetsConfirm: AssetsConfirmReducer,
  bitacora: BitacoraReducer,
  users: UsersReducer,
  invite: InviteReducer,
  intl: intlReducer,
  permission: PermissionReducer,
  group: GroupReducer,
  hoverVerticalView: HoverVerticalReducer,
  notifications: NotificationReducer,
  jobs: JobsReducer,
  comments: CommentReducer,
  downloads: DownloadReducer,
  middleView: MiddleViewReducer,
  bunkeyHost: BunkeyHostReducer,
  countryCodes: CountryCodesReducer,
  planServices: PlanServicesReducer,
  selectedFiles: MultiselectReducer,
  storage: StorageReducer,
  tours: ToursReducer,
  trash: TrashReducer,
  uploadFolder: UploadFolderReducer,
  individualSelect: IndividualSelectReducer,
  awsAuth: awsAuthReducer, // Added for AWS Auth
})

export default rootReducer
